<template>
  <div class="checkBox" v-if="jstatus !== 10 || status !== 10">
    <unifiedHeader />
    <div class="checkResult">
      <div class="title">审核进度</div>
      <div class="box box1" v-if="jstatus === 0 || status === 0">
        <div>
          <img src="../../assets/icon/checking.png" alt />
        </div>
        <p>您好，您的注册信息正在审核中，请耐心等待......</p>
        <p
          v-if="
            this.$route.query.userType == 2 || this.$route.query.userType == 4
          "
        >
          更多资讯请关注“熊洞智家技师之家”订阅号
        </p>
        <p v-if="this.$route.query.userType == 5">
          更多资讯请关注“熊洞智家资讯”订阅号
        </p>
        <div class="btn">
          <el-button @click="follow">熊洞智家资讯</el-button>
        </div>
      </div>

      <div class="box" v-if="jstatus === 1 || status === 2">
        <div>
          <img src="../../assets/icon/checkNo.png" alt />
        </div>
        <p>
          您提交的申请未通过审核，请修改后重新提交，如需帮助，请拨打400-155-5151
        </p>
        <div class="btn">
          <el-button @click="update">点击修改信息</el-button>
        </div>
      </div>
      <div class="successTime box" v-if="status === 1">
        <div>
          <img src="../../assets/icon/checkOk.png" alt />
        </div>
        <p>
          您好，您的注册信息已审核通过，更多操作请点击按钮，进入账户控制台。
        </p>
        <div class="btn" @click="optIdentity">
          <el-button>账户控制台按钮</el-button>
        </div>
      </div>
      <div class="box" v-if="status === 3">
        <div>
          <img src="../../assets/icon/checkOk.png" alt />
        </div>
        <p>提交成功，请等待平台审核，如需帮助，请拨打400-155-5151</p>
      </div>
    </div>
  </div>
</template>

<script>
import cryptoPhp from "../../libs/common/cryptoPhp"; // 加密解密文件
import unifiedHeader from "@/components/common/unifiedHeader"; // 统一头部
import { workApi } from "@/api/";
import { mapGetters, mapActions } from "vuex";
import { USER_SIGNIN } from "@/store/auth";
export default {
  data() {
    return {
      jstatus: 10, // 0待审核、1审核未通过、2审核已通过、3未上传信息成为技师、4已成为技师
      status: 10, // 0待审核、1已审核、2审核驳回、4账号冻结
      jsId: null,
      message: "原因",
      userId: null,
      successTime: 3,
      resultMessage: "审核成功"
    };
  },
  computed: {
    ...mapGetters(["user"])
  },
  beforeRouteLeave(form, to, next) {
    clearInterval(this.timer);
    next();
  },
  methods: {
    // 跳转供应台，选择后台
    optIdentity() {
      let idUser = this.user ? this.user : {};
      let jrwyToken = cryptoPhp.Encrypt(idUser.jrwyToken);
      let backUrl = `${
        process.env.VUE_APP_AUTH_URL
      }/optIdentity?jrwyToken=${encodeURIComponent(jrwyToken)}`;
      window.location.href = encodeURI(backUrl);
    },
    // 下载技师app
    downJsApp() {
      if (window.innerWidth > 750) {
        // pc 扫码
        this.$notify({
          title: "扫描下载app",
          dangerouslyUseHTMLString: true,
          message:
            '<img  style="width: 180px;height: 180px" src="https://file.juranguanjia.com/2019-04-29/5245260072254dffae0faf46b2b78fb0.jpg"></img>'
        });
      } else {
        location.href = "https://www.juranguanjia.com/downapp";
      }
    },
    follow() {
      // pc 扫码
      // 技师服务商
      if (
        this.$route.query.userType - 0 === 2 ||
        this.$route.query.userType - 0 === 4
      ) {
        this.$notify({
          title: "微信扫一扫，关注订阅号",
          dangerouslyUseHTMLString: true,
          message:
            '<img  style="width: 180px;height: 180px" src="https://file.juranguanjia.com/2019-04-29/a86bff323c494212b63b97ddd1006739.jpg"></img>'
        });
        // 供应商
      } else if (this.$route.query.userType - 0 === 5) {
        this.$notify({
          title: "微信扫一扫，关注订阅号",
          dangerouslyUseHTMLString: true,
          message:
            '<img  style="width: 180px;height: 180px" src="https://file.juranguanjia.com/2019-09-27/b91a149d6d564fdd9b99ca0e0f59b3a3.png"></img>'
        });
      }
    },
    // 通过userid 换去技师id
    async getJsId() {
      this.jsId = this.$route.query.addId;
      this.jsIdGetDetail();
    },
    // 根据技师id 获取详情（0待审核、1审核未通过、2审核已通过、3未上传信息成为技师、4已成为技师）
    async jsIdGetDetail() {
      let JsDetail = await workApi.getDetail();
      if (JsDetail.data.statusCode === 200) {
        this.jstatus = JsDetail.data.data;
        if (this.jstatus === 4) {
          this.setUserFunc(4);
          let idUser = this.user ? this.user : {};
          let jrwyToken = cryptoPhp.Encrypt(idUser.jrwyToken);
          let backUrl = `${
            process.env.VUE_APP_AUTH_URL
          }/optIdentity?jrwyToken=${encodeURIComponent(jrwyToken)}`;
          window.location.href = encodeURI(backUrl);
          return false;
        }
        if (this.jstatus === 3) {
          this.setUserFunc(3);
          this.$router.push("/worker/workerInfo?userType=2");
          return false;
        }
        if (this.jstatus === 2) {
          this.timer = setInterval(() => {
            this.successTime--;
            if (this.successTime === 0) {
              clearInterval(this.timer);
              this.successTime = 3;
              let idUser = this.user ? this.user : {};
              let jrwyToken = cryptoPhp.Encrypt(idUser.jrwyToken);
              let backUrl = `${
                process.env.VUE_APP_AUTH_URL
              }/optIdentity?jrwyToken=${encodeURIComponent(jrwyToken)}`;
              window.location.href = encodeURI(backUrl);
            }
          }, 1000);
        }
      }
    },
    // 设置 user
    setUserFunc(num) {
      this.user.identityList.forEach(val => {
        if (val.userType === 2) {
          val.auditStatus = num;
        }
      });
      this.USER_SIGNIN(this.user);
    },
    // 获取服务商供应商审核结果// 0：待审核，1：已审核 2：审核驳回 4：账号冻结
    async ResultMerchantinfo(userType) {
      let ResultMerchantinfo = await workApi.ResultMerchantinfo(userType);
      if (ResultMerchantinfo.data.statusCode === 200) {
        this.status = ResultMerchantinfo.data.data;
        if (this.status === 4) {
          let idUser = this.user ? this.user : {};
          let jrwyToken = cryptoPhp.Encrypt(idUser.jrwyToken);
          let backUrl = `${
            process.env.VUE_APP_AUTH_URL
          }/optIdentity?jrwyToken=${encodeURIComponent(jrwyToken)}`;
          window.location.href = encodeURI(backUrl);
          return false;
        }
        if (this.status === 3) {
          this.$router.push("/worker/workerInfo?userType=" + userType);
          return false;
        }
        if (this.status === 2) {
          this.timer = setInterval(() => {
            this.successTime--;
            if (this.successTime === 0) {
              clearInterval(this.timer);
              this.successTime = 3;
              let idUser = localStorage.getItem("id_user")
                ? JSON.parse(localStorage.getItem("id_user"))
                : {};
              let jrwyToken = cryptoPhp.Encrypt(idUser.jrwyToken);
              let backUrl = `${
                process.env.VUE_APP_AUTH_URL
              }/optIdentity?jrwyToken=${encodeURIComponent(jrwyToken)}`;
              window.location.href = encodeURI(backUrl);
            }
          }, 1000);
        }
      }
    },
    // 修改技师
    update() {
      if (this.$route.query.userType - 0 === 2) {
        // 修改技师
        this.$router.push({
          path: "/worker/workerInfo",
          query: {
            jsId: this.jsId,
            userType: this.$route.query.userType,
            userId: this.userId
          }
        });
      } else {
        // 修改供应商
        this.$router.push({
          path: "/worker/workerInfo",
          query: {
            userType: this.$route.query.userType,
            userId: this.userId
          }
        });
      }
    },
    ...mapActions([USER_SIGNIN])
  },
  components: {
    // sHeader
    unifiedHeader
  },
  activated() {
    this.timer = null;
    if (this.$route.query.userType - 0 === 2) {
      this.getJsId(); // 获取技师审核详情
    } else if (this.$route.query.userType - 0 === 4) {
      this.ResultMerchantinfo(4); // 获取服务商供应商审核结果
    } else if (this.$route.query.userType - 0 === 5) {
      this.ResultMerchantinfo(5); // 获取服务商供应商审核结果
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/styles/common.less";
.checkBox {
  position: absolute;
  top: 0;
  width: 100%;
  bottom: 0;
  background-color: #f4f4f4;
  // background-color: #fff;
  .checkResult {
    position: absolute;
    top: 10%;
    z-index: 10;
    width: 720 / @f;
    margin: 19 / @f auto;
    left: 50%;
    transform: translate(-50%, 0);
    margin-top: 0;
    font-size: 19 / @f;
    background-color: white;
    border-radius: 8 / @f;
    overflow: hidden;
    .title {
      background-color: @Mcolor;
      height: 57 / @f;
      line-height: 57 / @f;
      text-align: center;
      color: white;
      font-weight: bold;
    }
    .info {
      color: @Mcolor;
    }
    .box {
      height: 375 / @f;
      text-align: center;
      img {
        margin-top: 80 / @f;
        width: 56 / @f;
        height: 64 / @f;
      }
      > p {
        margin-top: 24 / @f;
        margin-bottom: 56 / @f;
        font-size: 13 / @f;
        padding: 10 / @f;
      }
      @{deep} .el-button {
        padding: 0 10 / @f;
        color: white;
        background-color: @Mcolor;
        // width: 136 / @f;
        height: 32 / @f;
        text-align: center;
        line-height: 32 / @f;
        font-size: 13 / @f;
        margin-right: 30 / @f;
      }
      @{deep} .el-button:last-child {
        margin-right: 0;
      }
    }
    .box1 {
      > p {
        font-size: 13 / @f;
        padding: 10 / @f;
        margin-top: 10 / @f;
        margin-bottom: 10 / @f;
      }
    }
    .successTime {
      text-align: center;
      a {
        cursor: pointer;
        color: @Mcolor;
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .checkBox {
    background: #fff;
    .checkResult {
      top: 80 / @f;
      width: 80%;
      font-size: 15 / @f;
      .title {
        display: none;
      }
    }
  }
}
</style>
